var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMonitor1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 0.779,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ec6e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f0bbb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3143",
    "data-name": "Rectangle 3143",
    width: 80,
    height: 80,
    transform: "translate(16292 1488)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_monitor",
    transform: "translate(-16292 -1488)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9151",
    "data-name": "Group 9151",
    transform: "translate(16296.724 1496.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_285",
    "data-name": "Union 285",
    d: "M51.438,62.667H19.114a3.085,3.085,0,0,1-.356.019,3.126,3.126,0,0,1-3.094-2.629,3.124,3.124,0,0,1,3.091-2.632,3.489,3.489,0,0,1,.36.019h7V52.222H5.223A5.227,5.227,0,0,1,0,47V5.224A5.225,5.225,0,0,1,5.223,0H65.329a5.227,5.227,0,0,1,5.223,5.224V47a5.229,5.229,0,0,1-5.223,5.221H44.442v5.223h7a3.493,3.493,0,0,1,.359-.019,3.123,3.123,0,0,1,3.088,2.632,3.122,3.122,0,0,1-3.091,2.629A3.089,3.089,0,0,1,51.438,62.667ZM5.223,47H65.329V5.224H5.223ZM21.275,26.238a.888.888,0,0,1,0-.852,15.588,15.588,0,0,1,27.41,0,.888.888,0,0,1,0,.852,15.593,15.593,0,0,1-27.41,0ZM28.4,25.81a6.583,6.583,0,1,0,6.583-6.584A6.584,6.584,0,0,0,28.4,25.81Zm3.227,0a3.387,3.387,0,0,1,.1-.8A1.74,1.74,0,0,0,34.6,23.688a1.717,1.717,0,0,0-.423-1.135,3.234,3.234,0,0,1,.8-.1,3.354,3.354,0,1,1-3.356,3.355Z",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMonitor1);
export default __webpack_public_path__ + "static/media/ic_monitor_1.e81ccb90e7362af3f537516dca5b2383.svg";
export { ForwardRef as ReactComponent };